import React, { useState, useRef, useEffect } from "react";
import "./index.css"; // External CSS file\imp
import store from "store";
import { imageMediaUrl } from "../../util/config";
import { Link } from "react-router-dom";
import moment from "moment";
import CircularProgress from "../../components/CircularProgress";
import CampaignRiskLineChart from "./lineChart";

const TraineeProgress = () => {
  const [traineeData, setTraineeProgress] = useState([]);
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [currentPage, setCurrentPage] = useState(1);
  const [first, setFirst] = useState("");
  const [second, setSecond] = useState("");
  const [third, setThird] = useState("");
  const [userRank, setUserRank] = useState(0);
  const [allUsers, setTotalUsers] = useState();

  const usersPerPage = 10;
  const visiblePages = 5;
  const half = Math.floor(visiblePages / 2);

  let start = Math.max(currentPage - half, 1);
  let end = Math.min(start + visiblePages - 1, totalPages);

  // Adjust start if near the end
  if (end - start < visiblePages - 1) {
    start = Math.max(end - visiblePages + 1, 1);
  }

  // Calculate pagination
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = traineeData.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(traineeData.length / usersPerPage);

  const goToPage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Placeholder user avatar image
  const avatarUrl =
    "https://storage.googleapis.com/workspace-0f70711f-8b4e-4d94-86f1-2a93ccde5887/image/134ed1bc-85a6-4f78-9b1f-fab0728ce9b3.png";

  let userInfo = store.get("user");
  const getTraineeProgress = async (setTraineeProgress, setLoading) => {
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const url = apiUrl + "api/trainee/trackProgress";
    const accessToken = localStorage.getItem("accessToken");

    const params = new URLSearchParams({ page: 0 });

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 seconds

    try {
      const res = await fetch(url + "?" + params.toString(), {
        method: "GET",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!res.ok) {
        if (res.status === 401) {
          if (window.message && window.message.error) {
            window.message.error(
              "Your session has been expired. Please relogin."
            );
          }
          localStorage.clear();
          window.location.reload();
          throw new Error("Session expired");
        } else {
          if (window.message && window.message.error) {
            window.message.error("Some error has occurred.");
          }
          throw new Error("API error");
        }
      }

      const response = await res.json();
      console.log(response.data, "Result here");
      setTraineeProgress(response.data || []);
    } catch (err) {
      if (err.name === "AbortError") {
        if (window.message && window.message.error) {
          window.message.error("Request timed out. Please try again later.");
        }
      } else if (
        err.message !== "Session expired" &&
        err.message !== "API error"
      ) {
        if (window.message && window.message.error) {
          window.message.error("Some error has occurred.");
        }
      }
      console.error("Failed to fetch trainee progress:", err);
    } finally {
      setLoading(false); // ✅ Called after success or failure
    }
  };

  useEffect(() => {
    setLoading(true);
    getTraineeProgress(setTraineeProgress, setLoading);
  }, []);

  return (
    <div>
      <div
        className="welcome-section-leaderboard"
        style={{ backgroundColor: "#F5F5F5" }}
      >
        <h2 style={{ textAlign: "center" }} className="sub-title">
          Trainee Progress
        </h2>
      </div>
      {loading ? (
        <CircularProgress></CircularProgress>
      ) : (
        <div style={{ backgroundColor: "#F5F5F5" }}>
          <div className="centre-box">
            <div className="gradient-box" style={{width:'80%'}}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "flex-end", // align medals along bottom
                  height: "335px",
                }}
              >
                <CampaignRiskLineChart campaignData={traineeData} />
              </div>
            </div>
          </div>

          <div className="leaderboard-container" style={{maxWidth:"80%"}}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <div className="pagination">
                <button
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{ fontSize: "18px", marginRight: "8px" }}
                >
                  ◀
                </button>
                <span style={{ margin: "11px 8px" }}>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{ fontSize: "18px", marginLeft: "8px" }}
                >
                  ▶
                </button>
              </div>
            </div>

            <table className="leaderboard-table">
              <thead>
                <tr>
                  <th>Simulation Name</th>

                  <th>Risk Score</th>
                  <th>Opened</th>
                  <th>Clicked</th>
                  <th>Entered Credentials</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.map((user, index) => (
                  <tr key={index} className={index % 2 === 0 ? "even" : "odd"}>
                    <td>{user.campaignId.name}</td>
                    <td>{user.riskScore}</td>
                    <td>{user.mailOpened ? "Yes" : "No"}</td>
                    <td>{user.mailClicked ? "Yes" : "No"}</td>
                    <td>{user.enteredCredentials ? "Yes" : "No"}</td>

                    <td>
                      {moment(user.campaignId.createdAt).format(
                        "YYYY-MM-DD HH:mm"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default TraineeProgress;
